/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "@polymer/polymer/lib/elements/dom-if";
import template from "./ns-featured-panel-link.html";

/**
 * <p>This component probably needs an overhaul.</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-featured-panel-link></ns-featured-panel-link>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsFeaturedPanelLink extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  connectedCallback() {
    super.connectedCallback();
    if (
      this.colorBlock === "Blue" &&
      this.backgroundType === "half image half block"
    ) {
      this.addEventListener("dom-change", () => {
        this.shadowRoot.querySelector("#link-text").style["color"] = "#FFFFFF";
      });
    }
  }

  static get is() {
    return "ns-featured-panel-link";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      backgroundType: String,
      colorBlock: {
        type: String
      },
      link: {
        type: Object,
        value: {},
        observer: "_linkChanged"
      },
      isButton: {
        type: Boolean,
        value: false
      },
      isLinkWithIcon: {
        type: Boolean,
        value: false
      },
      isTextLink: {
        type: Boolean,
        value: false
      }
    };
  }

  _linkChanged(newVal, oldVal) {
    if (newVal.type === "Button" && this.backgroundType === "Card Only") {
      this.isButton = true;
    } else if (newVal.type === "Link with Icon") {
      this.isLinkWithIcon = true;
    } else if (newVal.type === "Text Link") {
      this.isTextLink = true;
    }
  }

  _onClick() {
    let url = this.target;
    if (url.indexOf("http") !== 0 && url.indexOf(".html") === -1) {
      url = url + ".html";
    }
    window.open(url, "_self");
  }
}

customElements.define(NsFeaturedPanelLink.is, NsFeaturedPanelLink);
